import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './RadioButton.css';
import Icon from '../Icon';

const cx = classnames.bind(styles);

function RadioButton({className, onClick, checked, label, variant, withIcon, disabled}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className),
        [variant]: Boolean(variant),
        withIcon,
        checked,
        disabled
    });

    const handleClick = e => {
        e.preventDefault();
        e.stopPropagation();

        if (onClick) {
            onClick(e);
        }
    };

    return (
        <label
            className={classes}
            onClick={handleClick}
        >
            <input
                type='radio'
                checked={checked ? 'checked' : ''}
                readOnly
            />
            <span className={styles.checkmark}>
                {withIcon && checked && <Icon type='checked' />}
            </span>
            {label}
        </label>
    );
};

RadioButton.propTypes = {
    className: PropTypes.string,
    onClick: PropTypes.func,
    checked: PropTypes.bool,
    label: PropTypes.any.isRequired,
    variant: PropTypes.string,
    withIcon: PropTypes.bool,
    disabled: PropTypes.bool
};

RadioButton.defaultProps = {
    onClick: null,
    className: '',
    checked: false,
    withIcon: false,
    disabled: false,
    variant: 'primary'
};

export {
    RadioButton
};
